import {Component, Input} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.css']
})
export class BrandsComponent {
@Input() brand: any;
constructor(private router: Router) {
}
  navigateURL(brand: any) {
    this.router.navigateByUrl(`/search?brand=${brand.name}&categoryId=3`);
  }
}
